import { DepartmentAssignment, GroupOverviewDepartment, GroupOverviewItem } from '../model';

// Pivots department->groups into group(name)->departments. The same group_id name
// can exist under multiple departments, so we aggregate by name. A user belongs to
// exactly one department, so summing per-department user counts never double-counts.
export function buildGroupOverview(departments: DepartmentAssignment[]): GroupOverviewItem[] {
  const buckets = new Map<string, GroupOverviewItem>();

  departments.forEach((department) => {
    const name = department.name || department.code;
    const userCount = department.users.length;

    department.groups.forEach((group) => {
      const entry: GroupOverviewDepartment = { id: department.id, name, userCount };
      const existing = buckets.get(group.group_id);

      if (existing) {
        existing.departments.push(entry);
        existing.totalUsers += userCount;
      } else {
        buckets.set(group.group_id, {
          groupId: group.group_id,
          departments: [entry],
          totalUsers: userCount,
        });
      }
    });
  });

  return Array.from(buckets.values()).sort((a, b) => a.groupId.toLowerCase().localeCompare(b.groupId.toLowerCase()));
}
